const initialState = {
    recents: [],
    isReadingRecents: false,
    isReadingAccountRecents: false,
    isAddingRecent: false
}

export default initialState;
